import React, {useState} from 'react'
import {FaBars, FaTimes, FaGithub, FaLinkedin, FaInstagram, FaFacebook} from 'react-icons/fa'
import {Link} from 'react-scroll';
import { motion } from 'framer-motion';

//logo
import devStreamlogo from '../assets/devStreamlogo.png';

const divVariant = {
    init:{
        opacity:0,
    },
    animate:{
        opacity: 1,
    }
}

const ulVariant = {
    hover:{
        scale:1.1,
        x:'100px',
        transition:{
            duration:0.3,
            ease:'linear'
        }
    }
}

const NavBar = () => {
    const [nav, setNav] = useState(false);
    const handleClick = () => {
        setNav(!nav);
    };
  return (
    <motion.div className='flex justify-between items-center px-4 w-full h-[80px]
    bg-[#0a192f] text-gray-300'
    variants={divVariant}
    initial='init'
    animate='animate'
    >
        <div className='flex items-center gap-2'>
            <img src={devStreamlogo} className='w-12 h-12'/>
            <p className=' font-semibold'>netPrime</p>
        </div>
        {/*Menu*/}
            <motion.ul className='hidden md:flex'
            variants={ulVariant}
            >
                <li>
                    <Link to="home" spy={true} smooth={true} offset={50} duration={500}>
                        Home
                    </Link>
                </li>
                <li>
                    <Link to="about" spy={true} smooth={true} offset={50} duration={500}>
                        About
                    </Link>
                </li>
                <li>
                    <Link to="skills" spy={true} smooth={true} offset={50} duration={500}>
                        Skills
                    </Link>
                </li>
                <li>
                    <Link to="work" spy={true} smooth={true} offset={50} duration={500}>
                        Work
                    </Link>
                </li>
                <li>
                    <Link to="contact" spy={true} smooth={true} offset={50} duration={500}>
                        Contact
                    </Link>
                </li>
            </motion.ul>
        {/*Hamburger */}
        <div onClick={handleClick} className='md:hidden z-20 cursor-pointer'>
            {!nav ? <FaBars size={20} /> : <FaTimes size={20}/>}
        </div>
        {/*Mobile menu */}
        <div className={!nav ? 'hidden' : 'absolute top-0 z-10 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center'}>
            <ul>
                <li className='py-6 text-4xl'>
                    <Link onClick={handleClick} to="home" spy={true} smooth={true} offset={50} duration={500}>
                        Home
                    </Link>
                </li>
                <li className='py-6 text-4xl'>
                    <Link onClick={handleClick} to="about" spy={true} smooth={true} offset={50} duration={500}>
                        About
                    </Link>
                </li>
                <li className='py-6 text-4xl'>
                    <Link onClick={handleClick} to="skills" spy={true} smooth={true} offset={50} duration={500}>
                        Skills
                    </Link>
                </li>
                <li className='py-6 text-4xl'>
                    <Link onClick={handleClick} to="work" spy={true} smooth={true} offset={50} duration={500}>
                        Work
                    </Link>
                </li>
                <li className='py-6 text-4xl'>
                    <Link onClick={handleClick} to="contact" spy={true} smooth={true} offset={50} duration={500}>
                        Contact
                    </Link>
                </li>
            </ul>
        </div>
        {/*Social icon */}
        <div className='hidden lg:flex fixed top-[35%] left-0 flex-col'>
            <ul>
                <motion.li className='flex justify-between items-center w-[160px] h-[60px] ml-[-100px] duration-300 bg-blue-600'
                    variants={ulVariant}
                    whileHover='hover'
                >
                    <a href="https://www.linkedin.com/company/net-prime" className='flex justify-between items-center text-gray-300 w-full'>
                        Linkedin<FaLinkedin size={30}/>
                    </a>
                </motion.li>
                <motion.li className='flex justify-between items-center w-[160px] h-[60px] ml-[-100px] duration-300 bg-[#333333]'
                 variants={ulVariant}
                 whileHover='hover'
                >
                    <a href="https://github.com/netprime77" className='flex justify-between items-center text-gray-300 w-full'>
                        Github<FaGithub size={30}/>
                    </a>
                </motion.li>
                <motion.li className='flex justify-between items-center w-[160px] h-[60px] ml-[-100px] duration-300 bg-blue-600'
                 variants={ulVariant}
                 whileHover='hover'
                >
                    <a href="https://www.facebook.com/netPrime77" className='flex justify-between items-center text-gray-300 w-full'>
                        Facebook <FaFacebook size={30}/>
                    </a>
                </motion.li>
                <motion.li className='flex justify-between items-center w-[160px] h-[60px] ml-[-100px] duration-300' id='insta'
                 variants={ulVariant}
                 whileHover='hover'
                >
                    <a href="https://www.instagram.com/netprime77/" className='flex justify-between items-center w-full'>
                        Instagram<FaInstagram size={30}/>
                    </a>
                </motion.li>
            </ul>
        </div>
    </motion.div>
  )
}

export default NavBar